import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { FilingConductorIntegrationListResponse } from './types';

/** Lists the corporation's RootFi integrations and the sales models each one syncs. */
export function useFilingConductorIntegrations(corporationId: number | null) {
  const key = corporationId ? `filing-conductor/corporations/${corporationId}/integrations` : null;

  const { data, error, isLoading, mutate } = useSWR<FilingConductorIntegrationListResponse>(
    key,
    SWRFetcher({ method: 'GET' })
  );

  return {
    integrations: data?.integrations ?? [],
    isLoading,
    error,
    mutate,
  };
}
